import { datetime } from "../../../util/library/datetime";
import { SHORT_DATETIME_FORMAT } from "../../../util/varibles/constants";
import { IActivityLog } from "../../../util/varibles/interface";
import Icon, { ICON_NAME } from "../../Icon";

export const SitePoint = ({ name }: { name: string }) => {
    return <div className='text-[15px] font-[600] color-thirdc flex gap-1 items-center'>
        <Icon icon={ICON_NAME.SITE} />
        <span className="font-[--color1]">{name}</span>
    </div>
}

interface IProps {
    data: IActivityLog
    locationName: string
}

export default function SiteStep({ data, locationName }: IProps) {
    return <div className='flex flex-col items-center'>
        <div className='text-comment'>{datetime(data.est_start_time).format(SHORT_DATETIME_FORMAT)}</div>
        {data.real_start_time && <span>{datetime(data.real_start_time).format(SHORT_DATETIME_FORMAT)}</span>}
        <SitePoint name={locationName} />
    </div>
}